import { useAppContext } from '@src/logic/contexts/AppStore/AppContext'
import { useUserContext } from '@src/logic/contexts/AppStore/UserContext'
import { type User } from '@src/logic/contexts/AppStore/UserContext'

type AccountSettings = {
  [key: string]: {
    user_scope: string[]
    app_scope: string[]
    effective_value: string | number | boolean
  }
}

// check RBVAC for account settings which current user signed in 

export const checkAccSettingsScope = (settingKey: string): {canAccess: boolean, effectiveValue?: string | number | boolean}  => {
  const { globals } = useAppContext()

  const { currentUser, isUserLoading } = useUserContext() as {
    currentUser: User | null
    isUserLoading: boolean
  }

  if (
    !settingKey ||
    isUserLoading ||
    !currentUser ||
    !globals?.accSettings?.[settingKey]
  ) {
    return { canAccess: false }
  }

  // Check if user's role is in the rbac array
  const { user_scope, effective_value, app_scope } = globals.accSettings[settingKey]

  if (
    !user_scope?.includes(currentUser.userRole) ||
    !app_scope?.includes("web_app")
  ) {
    return { canAccess: false };
  }

  return { canAccess: true, effectiveValue: effective_value }

}



// check RBAC for account settings for any account by passing the parituclar accounts  account_settings
export const checkAccSettingsScopeWithSettings = (
  settingKey: string, 
  accSettings: AccountSettings
): {canAccess: boolean, effectiveValue?: string | number | boolean} => {
  const { currentUser, isUserLoading } = useUserContext() as {
    currentUser: User | null
    isUserLoading: boolean
  }

  if (
    !settingKey ||
    isUserLoading ||
    !currentUser ||
    !accSettings?.[settingKey]
  ) {
    return { canAccess: false }
  }

  // Check if user's role is in the rbac array
  const { user_scope, effective_value, app_scope } = accSettings[settingKey]

  if (
    !user_scope?.includes(currentUser.userRole) ||
    !app_scope?.includes("web_app")
  ) {
    return { canAccess: false };
  }

  return { canAccess: true, effectiveValue: effective_value }
}
